/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-30 14:56:25
 * @FilePath: \hlweb2.0\src\pages\Solution\Asset\Product\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { Image, Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./index.scss";
function Product() {
  const { t } = useTranslation();
  const productInfo = t("solution_asset.asset7", {
    returnObjects: true,
  });
  return (
    <div className="product_side">
      <div className="product_top">
        <div className="product_title">
          <div>{productInfo.title}</div>
          <span>{productInfo.detail}</span>
        </div>
      </div>
      <div className="product_con">
        <div className="product_left">
          <div className="product_left_tab">{productInfo.tabsName}</div>
          <ul className="product_left_ul">
            {productInfo.contentList.map((item, index) => {
              return (
                <li className="product_left_li" key={index}>
                  <div className="product_left_li_icon">
                    <img src={productInfo.iconUrl} alt="" />
                  </div>
                  <div>{item}</div>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="product_right">
          <div className="product_right_det">
            {productInfo.pList.map((item, index) => {
              return <p key={index}>{item}</p>;
            })}
          </div>
          <ul className="product_right_ul">
            {productInfo.cardList.map((item, index) => {
              return (
                <li className="product_right_li" key={index}>
                  <div className="product_right_li_title">{item.title}</div>
                  <div className="product_right_li_detail">{item.detail}</div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Product;
